import { userActions } from './userSlice';
import { accountActions } from './accountSlice';
import {
  accountService,
  adminDashboardService,
  userService,
} from '../services';
import { CLOUD_PROVIDER_SERVICES } from '../utils/constants';
import { ALL_VALUE } from '../pages/Invoice/config';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchAllOrganizations = createAsyncThunk<
  any[],
  void,
  { rejectValue: string }
>('admin/fetchAllOrganizations', async (_, { rejectWithValue }) => {
  try {
    const response = await adminDashboardService.getAllOrgDetails();

    if (!response) {
      return rejectWithValue('Unable to fetch organization data');
    }

    return response;
  } catch (error: any) {
    return rejectWithValue(error?.message || 'Failed to fetch organizations');
  }
});

export const fetchUserData = () => {
  return async (dispatch: any) => {
    const fetchUserData = async () => {
      const response = await userService.getUserDetails();
      if (!response) {
        throw new Error('Unable to fetch data');
      }
      return response;
    };

    const fetchAccountData = async () => {
      const response = accountService.getSelectedAccount();
      if (!response) {
        throw new Error('Unable to fetch data');
      }
      return response;
    };

    try {
      const userData = await fetchUserData();
      let accountData = await fetchAccountData();

      dispatch(
        userActions.replaceUserState({
          userData: userData,
          isUserSelected: true,
        })
      );

      if (!accountData) {
        // localStorage.setItem(storageKeys.ACCOUNTS_PAGE_NO, value);
        accountData = { CloudProvider: CLOUD_PROVIDER_SERVICES.AWS };
        dispatch(
          accountActions.replaceAccountState({
            selectedAccount: accountData,
            isAccountSelected: false,
            selectedAccountName: ALL_VALUE,
            selectedSubscriptionName: ALL_VALUE,
            selectedAccountId: ALL_VALUE,
            selectedSubscriptionId: ALL_VALUE,
            selectedSubData: [],
          })
        );
      } else {
        // ✅ Check user accounts length
        if (userData?.UserAccounts?.length < 2) {
          // If only one account → keep actual account values
          dispatch(
            accountActions.replaceAccountState({
              selectedAccount: accountData,
              isAccountSelected: true,
              selectedAccountName: accountData?.Name || ALL_VALUE,
              selectedSubscriptionName: ALL_VALUE,
              selectedAccountId: accountData?.AccountId || ALL_VALUE,
              selectedSubscriptionId: ALL_VALUE,
              selectedSubData: [],
            })
          );
        } else {
          // If multiple accounts → reset to ALL_VALUE
          dispatch(
            accountActions.replaceAccountState({
              selectedAccount: accountData,
              isAccountSelected: true,
              selectedAccountName: ALL_VALUE,
              selectedSubscriptionName: ALL_VALUE,
              selectedAccountId: ALL_VALUE,
              selectedSubscriptionId: ALL_VALUE,
              selectedSubData: [],
            })
          );
        }
      }
    } catch (error) {
      // console.log(error);
    }
  };
};
